import React from 'react';
import { useNavigate } from 'react-router-dom';

// Assets
import mariaShrugSvg from '@repo/assets/maria-shrug.svg';
import atomBg from '@repo/assets/atom-bg.png';

// Components
import styled from 'styled-components';
import { PrimaryButton } from '@repo/ui';

interface Props {
  className?: string;
}

const NotFoundPage: React.FC<Props> = ({ className }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className={className}>
        <div
          className="container"
          style={{
            backgroundImage: `url(${atomBg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'repeat-y',
          }}
        >
          <div className="maria">
            <img src={mariaShrugSvg} alt="Maria shrugging" />
          </div>
          <div className="content">
            <h1>404</h1>
            <h2>Well, this is awkward.</h2>
            <p>Maria couldn't find that page, either.</p>
            <PrimaryButton onClick={() => navigate('/')}>Go to Login</PrimaryButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default styled(NotFoundPage)`
  .container {
    width: 100%;
    height: 100vh;
    max-width: none;
    display: flex;
    flex-direction: column-reverse;
    padding: 0 2rem;
  }

  .maria {
    width: 300px;
    margin-left: -100px;
  }

  h1 {
    font-size: 10rem;
    font-style: normal;
    font-weight: 600;
    line-height: 90%;
    letter-spacing: -11px;
    background: linear-gradient(90deg, #1bb6d9 2.53%, #4dc 78.04%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-top: 5rem;
  }

  h2 {
    color: #242424;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-size: 1.85rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
  }

  p {
    color: #242424;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0.5rem 0 2rem 0;
  }

  button {
    width: 250px !important;
    height: 58px !important;
    font-size: 0.875rem !important;
    border-radius: 8px;
  }

  .content {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  @media (min-width: 698px) {
    .container {
      display: flex;
      align-items: flex-end;
      flex-direction: row;
    }

    .maria {
      width: 440px;
      margin-left: -120px;
    }

    .content {
      height: 100vh;
    }

    h1 {
      font-size: 11rem;
    }

    h2 {
      font-size: 1.85rem;
    }

    p {
      font-size: 1.25rem;
    }
  }

  @media (min-width: 860px) {
    h1 {
      font-size: 14rem;
    }

    h2 {
      font-size: 2rem;
    }

    p {
      font-size: 1.65rem;
    }
  }

  @media (min-width: 1000px) {
    .maria {
      width: 500px;
      margin-left: -120px;
    }

    h1 {
      font-size: 18rem;
    }

    h2 {
      font-size: 3.25rem;
    }

    p {
      font-size: 2rem;
    }
  }

  @media (min-width: 1100px) {
    .maria {
      width: 600px;
    }

    h1 {
      font-size: 22rem;
    }

    h2 {
      font-size: 4rem;
    }

    p {
      font-size: 2rem;
    }
  }

  @media (min-width: 1400px) {
    .maria {
      width: 700px;
    }

    h1 {
      font-size: 22rem;
    }

    h2 {
      font-size: 4rem;
    }

    p {
      font-size: 2rem;
    }
  }

  @media (min-width: 1728px) {
    .maria {
      width: 800px;
    }

    h1 {
      font-size: 31rem;
      letter-spacing: -38px;
    }

    h2 {
      font-size: 6rem;
      letter-spacing: -5px;
    }

    p {
      font-size: 3.5rem;
    }
  }
`;
